<template>
  <div>
    <h1 :class="clasetext">{{ pregunta }}</h1>
    <div>
      <button :class="claseButton1" style="margin-right: 10px;" @click="responder(true)">{{respuesta_1}}</button>
      <button :class="claseButton2" style="margin-right: 10px;" @click="responder(false)">{{respuesta_2}}</button>
    </div>
  </div>
</template>
<style>
.btn-trivia {
  width: 90px;
  margin: 10px; /* Agrega un margen a la derecha */
}
</style>
<script>

export default {
  name: 'PreguntaTrivia',
  props: {
    clasetext: {
      type: String,
      required: true,
    },
    c13: {
      type: Boolean,
      required: true,
    },
    got: {
      type: Boolean,
      required: true,
    },
    bunkers: {
      type: Boolean,
      required: true,
    },
    mne: {
      type: Boolean,
      required: true,
    },
    festivallascondes: {
      type: Boolean,
      required: true,
    },
    gala: {
      type: Boolean,
      required: true,
    },
    miss: {
      type: Boolean,
      required: true,
    },
    festival: {
      type: Boolean,
      required: true,
    },
    mundos: {
      type: Boolean,
      required: true,
    },
    miss_mundo: {
      type: Boolean,
      required: true,
    },
    miss_chile: {
      type: Boolean,
      required: true,
    },
    finde: {
      type: Boolean,
      required: true,
    },
    coliseo: {
      type: Boolean,
      required: true,
    },
    chv_festivales: {
      type: Boolean,
      required: true,
    },
    fiebre: {
      type: Boolean,
      required: true,
    },
    fiebre_canto: {
      type: Boolean,
      required: true,
    },
    vecinos: {
      type: Boolean,
      required: true,
    },
    desestrece: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      claseButton1: null,
      claseButton2: null,
      pregunta: "¿Quién es el conductor de Tierra Brava?",
      respuesta_1: "Sergio Lagos",
      respuesta_2: "Martín Carcamo",
    };
  },
  methods: {
    responder(respuesta) {
      if (respuesta) {
        // Lógica para respuesta "Sí"
        this.$emit('changeValue', {
          triviaStatus: false,
          modal: false,
        });
      } else {
        // Lógica para respuesta "No"
        this.$emit('changeValue', {
          triviaStatus: false,
          modal: true,
        });
      }
    },
  },
  mounted() {
    if (this.c13) {
      this.pregunta = "¿Quién es el animador del programa?";
      this.respuesta_1 = "Martín Cárcamo";
      this.respuesta_2 = "Luis Slimming";
      this.claseButton1 = 'btn btn-gradiente-naranjo btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-naranjo btn-auto btn-block';
    }else if (this.finde) {
      this.claseButton1 = 'btn btn-gradiente-finde btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-finde btn-auto btn-block';
    }else if (this.got){
      this.pregunta = "¿Quién es el conductor de Got Talent?";
      this.respuesta_1 = "Julián Elfenbein";
      this.respuesta_2 = "Julio Cesar Rodriguez";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.bunkers){
      this.pregunta = "Los Bunkers son una banda de la ciudad de:";
      this.respuesta_1 = "Concepción";
      this.respuesta_2 = "Los Angeles";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.mne){
      this.pregunta = "¿Quien es el animador de Mi Nombre Es?";
      this.respuesta_1 = "Jean Philippe ";
      this.respuesta_2 = "Luis Jara";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.festivallascondes){
      this.pregunta = "¿Quién conduce el Festival de Las Condes?";
      this.respuesta_1 = "Cristián Riquelme";
      this.respuesta_2 = "Francisco Saavedra";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.gala || this.festival){
      this.pregunta = "¿Quíen es el animador del Festival de Viña?";
      this.respuesta_1 = "Rafael Araneda";
      this.respuesta_2 = "José Antonio Neme";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.miss){
      this.pregunta = "¿Quíen fue la participante chilena en Miss Universo 2024?";
      this.respuesta_1 = "Emilia Dides";
      this.respuesta_2 = "Cecilia Bolocco";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.miss_mundo){
      this.pregunta = "¿Miss Mundo es un concurso de…?";
      this.respuesta_1 = "Belleza";
      this.respuesta_2 = "Cocina";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.miss_chile){
      this.pregunta = "¿Miss Universo es un certamen de…?";
      this.respuesta_1 = "Belleza";
      this.respuesta_2 = "Cocina";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.fiebre){
      this.pregunta = "¿Quién anima Fiebre de Baile?";
      this.respuesta_1 = "Diana Bolocco";
      this.respuesta_2 = "Julián Elfenbein";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.fiebre_canto){
      this.pregunta = "¿Quién anima Fiebre de Canto?";
      this.respuesta_1 = "Diana Bolocco";
      this.respuesta_2 = "Julián Elfenbein";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if (this.vecinos){
      this.pregunta = "¿Sergio Lagos es el animador de Vecinos al Límite?";
      this.respuesta_1 = "Si";
      this.respuesta_2 = "No";
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }else if(this.mundos){
      this.claseButton1 = 'btn btn-gradiente-naranjo btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-naranjo btn-auto btn-block';
    }else if(this.coliseo){
      this.pregunta = "¿María José Quintanilla es la animadora de Coliseo Romano?";
      this.respuesta_1 = "Si";
      this.respuesta_2 = "No";
      this.claseButton1 = 'btn btn_coliseo btn-auto btn-block';
      this.claseButton2 = 'btn btn_coliseo btn-auto btn-block';
    }else if(this.chv_festivales){
      this.pregunta = "¿Quien animará el Festival de las Condes 2026?";
      this.respuesta_1 = "Diana Bolocco";
      this.respuesta_2 = "Emilia Daiber";
      this.claseButton1 = 'btn btn_coliseo btn-auto btn-block';
      this.claseButton2 = 'btn btn_coliseo btn-auto btn-block';
    // }else if(this.desestrece){
    //   this.pregunta = "¿El ejercicio es bueno para desestresarse?";
    //   this.respuesta_1 = "Si";
    //   this.respuesta_2 = "No";
    //   this.claseButton1 = 'btn btn-gradiente-naranjo btn-auto btn-block';
    //   this.claseButton2 = 'btn btn-gradiente-naranjo btn-auto btn-block';
    }else {
      this.claseButton1 = 'btn btn-gradiente-gold btn-auto btn-block';
      this.claseButton2 = 'btn btn-gradiente-blue-cyan btn-auto btn-block';
    }
  },
}; 
</script>
<style scoped>
.btn_coliseo {
  background: linear-gradient(45deg, #eaf3f5, #f2fdff);
  color: #000000;
}
.btn-gradiente-finde {
  background: #edb64b;
  color: #5f1b17;
  font-size: 1.125rem;
  font-weight: bold;
}
</style>